<template></template>
<script>
export default {
  mounted: function() {
    window.location.replace("https://ruanna.justicia.gob.bo");
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Ruanna/Ruanna.vue